import React from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import { connect } from 'react-redux';
import Loader from '../../../../components/Loader';

const UserDetailsModel = ({ profileModel, setProfileModel, authDetails }) => {

    const { loading, user } = authDetails;

    const closeProfileModel = () => setProfileModel(false)

    return (
        <>
            {
                profileModel ? (
                    <>
                        <div className='absolute w-full px-4 min-h-screen z-20' onClick={closeProfileModel} style={{ background: 'rgba(0, 0, 0, 0.54)' }}>
                            {loading ? <Loader /> : (
                                <div className='my-10 mx-auto max-w-md sen-font flex justify-center flex-col items-center bg-white p-4 rounded shadow'>
                                    <div onClick={closeProfileModel} className='flex ml-auto hover:bg-red-600 bg-gray-200 rounded-full p-2 cursor-pointer'>
                                        <IoCloseOutline className='text-2xl text-black hover:text-white' />
                                    </div>
                                    <h2 className='uppercase mont-font text-xl font-bold tracking-wider mb-4'>User Details</h2>
                                    <table className='border p-3'>
                                        <tbody>
                                            <tr className='border-b '>
                                                <th scope="row" className='p-3 '>ID :</th>
                                                <td className='p-3'>{user && user._id}</td>
                                            </tr>
                                            <tr className='border-b '>
                                                <th scope="row" className='p-3 '>Name :</th>
                                                <td className='p-3'>{user && user.name}</td>
                                            </tr>
                                            <tr className='border-b'>
                                                <th scope="row" className='p-3'>Email :</th>
                                                <td className='p-3'>{user && user.email}</td>
                                            </tr>
                                            <tr className='border-b'>
                                                <th scope="row" className='p-3'>Phone :</th>
                                                <td className='p-3'>{user && user.phone}</td>
                                            </tr>
                                            <tr className='border-b'>
                                                <th scope="row" className='p-3'>Role :</th>
                                                <td className='p-3'>{user && user.role}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </>
                ) : null
            }
        </>
    )
}


const mapStateToProps = (state) => ({
    authDetails: state.authDetails
})

export default connect(mapStateToProps,null )(UserDetailsModel);